import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { BillLocalModel } from "app/shared/models/bill.model";
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { environment } from "environments/environment";
import {
  AddAssigmentToFlightRQ,
  AssigmentService,
  BillModel,
  BillService,
  FlightListModel,
  FlightService,
  ListFlightByShippingRQ,
  ListOpenBillByAgencyRQ,
  ShippingListModel,
  ShippingService,
} from "app/open-api";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import { error } from "console";
import { DownloadPdfRQ } from 'app/open-api/model/downloadPdfRQ';
import { ShippingListRQ } from '../../open-api/model/ShippingListRQ';
import { ShippingType, shippingTypes } from '../../open-api/model/shippingType';

@Component({
  selector: "app-bash-to-flight",
  templateUrl: "./bash-to-flight.component.html",
  styleUrls: ["./bash-to-flight.component.scss"],
})
export class BashToFlightComponent implements OnInit {
  public basicSelectedOption: number = 5;
  public bills: BillLocalModel[] = [];
  public allBills: BillLocalModel[] = [];
  shippings: ShippingListModel[] = [];
  flights: FlightListModel[] = [];
  selectedShipping: ShippingListModel = null;
  selectedFlight: FlightListModel = null;
  selectedBills: BillLocalModel[] = [];
  selectedRowIds = new Set<string>();
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;
  shippingTypes: Array<ShippingType> = [];
  selectedShippingType: any;
  urlApi = environment.apiUrl;

  constructor(
    private _billService: BillService,
    private _shippingService: ShippingService,
    private _flightService: FlightService,
    private _assigmentService: AssigmentService,
    private _spinner: NgxSpinnerService,
    private _location: Location,
  ) {
    this.shippingTypes = shippingTypes;
  }

  ngOnInit(): void {
    this.FetchFlights();
    this.FetchModels();
  }

  FetchFlights() {
    const request: ShippingListRQ = {      
    }
    this._shippingService.apiShippingListGet(request).subscribe((response) => {
      this.shippings = response.list;
    });
  }  

  async FetchShippingsByType() {  
    this._spinner.show();  
    this.shippings = [];
    this.flights = [];
    this.selectedShipping = null;
    this.selectedFlight = null;
    const request: ShippingListRQ = {  
      shippingType: this.selectedShippingType
    }

    await this._shippingService.apiShippingListGet(request).toPromise()
    .then(async response =>  {
      this.shippings = response.list;      
      //await this.FetchModelsFiltered();
    });
    this._spinner.hide();
  }

  DownloadPdf(billId: number){
    this._spinner.show();
    const param: DownloadPdfRQ = {
      billId: billId
    }

    this._billService.apiDownloadPdfPost(param).subscribe(response => {
      //console.log();
      const fileURL = URL.createObjectURL(response);
      window.open(fileURL, '_blank');

      Swal.fire({
        title: `El pdf se descargó satisfactoriamente.`,
        icon: 'success',
        showConfirmButton: false,
        timer: 5000,
        position: 'top'
      });

      this._spinner.hide();
    }, error => {
      //console.warn(error);
      Swal.fire({
        title: 'Error! ' + error.error,
        icon: 'error',
        showConfirmButton: false,
        timer: 5000,
        position: 'top'
      });
      this._spinner.hide();
    });   
  
  }

  async FetchModelsFiltered() {
    this._spinner.show();
    const param: ListOpenBillByAgencyRQ = {
      agencyId: null,
      shippingType: this.selectedShippingType,
      shippingId: this.selectedShipping?.id ?? null,
      flightId: this.selectedFlight?.id ?? null
    };
    await this._billService.apiBillGetOpenBillByAgencyPost(param).toPromise()
    .then(response => {
        this.bills = this.ModelParse(response.list);
        this.allBills = this.ModelParse(response.list);
        this.selectedBills = [];
        this._spinner.hide();
      },
      (error) => {
        console.warn(error);
        this._spinner.hide();
      }
    );
  }

  FetchModels() {
    this._spinner.show();
    const param: ListOpenBillByAgencyRQ = {
      agencyId: null,
    };
    this._billService.apiBillGetOpenBillByAgencyPost(param).subscribe(
      (response) => {
        this.bills = this.ModelParse(response.list);
        this.allBills = this.ModelParse(response.list);
        this._spinner.hide();
      },
      (error) => {
        console.warn(error);
        this._spinner.hide();
      }
    );
  }

  ModelParse(array: BillModel[]): BillLocalModel[] {
    return array.map(({ customerModel, senderModel, ...rest }) => ({
      ...rest,
      customerModel: JSON.parse(customerModel || ""),
      senderModel: JSON.parse(senderModel || ""),
    }));
  }

  async GetFlightByShippingId() {
    this._spinner.show();
    if (this.selectedShipping) {
      const params: ListFlightByShippingRQ = {
        shippingId: this.selectedShipping.id,
      };
      this._flightService
        .apiFlightListByShippingPost(params).toPromise()
    .then(async response => {
          this.flights = response.list;
          //await this.FetchModelsFiltered();
          this._spinner.hide();
        });
    } else {
      this.flights = [];
      this._spinner.hide();
    }
  }

  cleanFilter(){
    this.selectedShipping = null;
    this.selectedFlight = null;
    this.selectedShippingType = null;
  }

  async asignBash() {
    const swal = Swal.fire({
      title: `¿Está seguro que desea asignar ${this.selectedBills.length} facturas a vuelo?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Asignar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-primary",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        this._spinner.show();       
        
        const param: AddAssigmentToFlightRQ = {
          flightId: this.selectedFlight.id,
          billsId: this.selectedBills.map((flight) => flight.id),
        };
        await this._assigmentService.apiAssigmentAddToFlightPost(param).toPromise()
        .then(async response => {
            this.FetchModels();
            this.cleanFilter();
            this.selectedBills = [];
            this._spinner.hide();
          },
          (error) => {
            console.warn(error);
            this._spinner.hide();
          }
        );        
      }
    });
  }

  onSelect(event: any) {    
    this.selectedBills = event.selected as BillLocalModel[];
  }

  Back(): void {
    this._location.back();
  }

  FilterUpdate(event) {
    if (event && event !== "") {
      this.bills = this.allBills.filter(
        (x) => x.code.toLowerCase().indexOf(event.toLowerCase()) > -1
      );
    } else {
      this.bills = this.allBills;
    }
  }

  GetURLById(id: number) {
    const bill = this.bills.find((b) => b.id === id);
    return this.urlApi + "/Bills/" + bill.file;
  }

  GetCodeById(id: number) {
    const bill = this.bills.find((b) => b.id === id);
    return bill.code;
  }
}
